import React, {FC} from 'react'

export const PageCard: FC = ({children}) => {
  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body p-9'>{children}</div>
    </div>
  )
}
